import { Loader } from "@googlemaps/js-api-loader";

const mapLoader = () =>
  new Loader({
    apiKey: process.env.NEXT_PUBLIC_MAPS_KEY as string,
    version: "weekly",
    libraries: ["places", "visualization"],
  }).load();

export default mapLoader;
